import Image from "next/image";
import Link from "next/link";

export function Logo() {
    return <Link href="/"><Image width={83} height={23} alt="" className="logo mx-5 my-4" src="/img/logo.svg" /></Link>
}

export function Spinner() {
    return <div className="mx-2 w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin inline-block"></div>
}
